export default __webpack_public_path__ + "static/media/vuesax-linear-filter-search.54d780f2.svg";